/** @jsx dom */
import Button from '@viskan/deku-button';
import {Cell, Grid} from 'viskan-deku-grid';
import deepEqual from 'deep-equal';
import dom from 'magic-virtual-element';
import {Form, InputField} from '@viskan/deku-form';

const onSubmit = props => data => props.addCampaignCode(data, false);

const shouldUpdate = ({props, state}, nextProps, nextState) => {
	if (!deepEqual(state, nextState)) {
		return true;
	}

	return !deepEqual(props, nextProps);
};

const render = ({props}) => {
	const {getTranslation, campCode, campCodeError} = props;

	return (
		<Form class='ShopcartDiscount' onSubmit={onSubmit(props)}>
			<Grid>
				<Cell size='full'>
					{campCodeError && <div class='DiscountError'>{getTranslation('shopcart.discount_error')}</div>}
					<div class='ShopcartDiscount-input'>
						<InputField name='camp_code' id='camp_code' placeholder={getTranslation('shopcart.discount_code')}/>
					</div>
				</Cell>
				<Cell size='1of2'>
					<div class='ShopcartDiscount-submit'>
						<Button class='Button--primary Button-discount'>{getTranslation('checkout.send_offer')}</Button>
					</div>
				</Cell>
			</Grid>
			{Boolean(campCode.length > 0) && <div>{getTranslation('shopcart.discount_success', {code: campCode})}</div>}
		</Form>
	);
};

export default {render, shouldUpdate};
